import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		iframe: {
			width: "100%",
			minHeight: 250,
			border: 0,
		},
		label: {
			minWidth: 140,
		},
		failedText: {
			fontSize: ".8rem",
			color: "red",
		}
	} satisfies Record<string, CSSObject>;
};
